import React, { useState, useEffect, useCallback, useRef } from 'react';
import Logo from "../images/logo.svg";
import Sidebar from '../component/Sidebar';
import { SelectPicker, DatePicker, Drawer, Placeholder, Whisper, Button, Popover, Message, useToaster, Tooltip, Input, Modal } from "rsuite";
import 'rsuite/SelectPicker/styles/index.css';
import { json, Link } from "react-router-dom";
import 'aos/dist/aos.css';
import AOS from 'aos';
import debounce from 'lodash.debounce';
import IconDelete from "../images/deleteBG.svg";
import IconInfo from "../images/IconErrorInfo.svg";
import IconError from "../images/IconError.svg";
import IconCheckError from "../images/IconCheckError.svg";

import icon_Asc from "../images/Asc.svg";
import icon_Desc from "../images/Desc.svg";

import icon1_Asc from "../images/Asc.svg";
import icon1_Desc from "../images/Desc.svg";

import icon2_Asc from "../images/Asc.svg";
import icon2_Desc from "../images/Desc.svg";

import icon3_Asc from "../images/Asc.svg";
import icon3_Desc from "../images/Desc.svg";

import iconArrowDrop from "../images/iconArrowDrop.svg";
import Icon_info from "../images/iconInfo.svg";
import mockData from "../sample/mockData.json";

import iconUS from "../images/flag/usa.svg";
import iconIN from "../images/flag/india.svg";
import iconBangla from "../images/flag/bangladesh.svg";
import iconUAE from "../images/flag/uae.png";
import iconsaudi from "../images/flag/saudi.svg";
import iconPakistan from "../images/flag/pakistan.svg";
import iconUK from "../images/flag/uk.svg";
import iconQatar from "../images/flag/qatar.svg";
import iconkuwait from "../images/kuwait.svg";
import iconbahrain from "../images/bahrain.svg";
import iconUSA from "../images/flag/usa.svg";

import iconWhatsapp from "../images/contact/Whatsapp.svg";
import iconMail from "../images/contact/mail.svg";
import iconPhone from "../images/contact/phone.svg";
import iconSMS from "../images/contact/MSG.svg";
import iconTelegram from "../images/contact/telegram.svg";
import iconZoom from "../images/contact/zoom.svg";

import iconGoogle from "../images/contact/google.svg";
import iconTwitter from "../images/contact/twitter.svg";
import iconNewsletter from "../images/contact/newsletter.svg";
import IconEye from "../images/iconEye.svg";

import { parsePhoneNumberFromString } from 'libphonenumber-js';
import IconRefresh from "../images/iconRefresh.svg";
import { encryptData, decryptData } from "./cryptoUtil";
import moment from 'moment-timezone';
import { ChakraProvider, useToast, Wrap } from '@chakra-ui/react'
import { CircleFlag } from 'react-circle-flags';


function Leads() {

  const [tabName, setTabName] = useState('Leads ');

  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

   const timeZone = 'Asia/Kolkata';

  const orderData = ['ASC', 'DESC'].map(
    item => ({ label: item, value: item })
  );

  const CBAStatus = ['Pass', 'Fail'].map(
    item => ({ label: item, value: item })
  );

  const statusData = [
    { label: 'Publish', value: true },
    { label: 'UnPublish', value: false },
    { label: 'Both', value: '' }
  ];

  useEffect(() => {
    AOS.init();
  }, []);


    const toast = useToast();
    const toastIdRef = React.useRef();


  
  const abortControllerRef = useRef(null);
  const [isLoading, setLoading] = useState(true); // State to manage loading state
    const [globalLoading, setGlobalLoading] = useState(true); // State to manage loading state
    const abortControllerRefGlobal = useRef(null);
  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const frontEndLink = process.env.REACT_APP_MUSAFFA_LINK;
  const roleName = localStorage.getItem("novaRolename");
  const merlinJuniorAnalyst = process.env.REACT_APP_MERLIN_JUNIOR_ANALYST;
  const [pageRange, setPageRange] = useState("20");
  const [reportdata, setReportData] = useState([]);
  const [reportCount, setReportCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [startPage, setStartPage] = useState(1);
  const [countryCode, setCountryCode] = useState("");
  const [complianceId, setComplianceId] = useState("");
  const [progressId, setProgressId] = useState("");
  const [scoreId, setScoreId] = useState("");

  const [orderBy, setOrderBy] = useState("investment_amount"); // default orderBy
  const [order, setOrder] = useState("DESC"); // default order

  const [statusId, setStatusId] = useState();
  const [searchInput, setSearchInput] = useState("");

  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");

  const [CMPTminValue, setCMPTMinValue] = useState("");
  const [CMPTmaxValue, setCMPTMaxValue] = useState("");

  const [NCMPTminValue, setNCMPTMinValue] = useState("");
  const [NCMPTmaxValue, setNCMPTMaxValue] = useState("");

  const [DBFTminValue, setDBFTMinValue] = useState("");
  const [DBFTmaxValue, setDBFTMaxValue] = useState("");

  const [IntrestminValue, setIntrestMinValue] = useState("");
  const [IntrestmaxValue, setIntrestMaxValue] = useState("");

  const [DEBTminValue, setDEBTMinValue] = useState("");
  const [DEBTmaxValue, setDEBTMaxValue] = useState("");

  const [countryData, setCountryData] = useState([]);
  const [complianceData, setComplianceData] = useState([]);

  const [selectedQuarter, setSelectedQuarter] = useState("");

  const userid = localStorage.getItem("novauserid");


  const [errorMessage, setErrorMessage] = useState('');
  const [messageType, setMessageType] = useState(null); // success, error, info
  const [assetClassData, setAssetClassData] = useState([]);
  const [searchAsset, setSearchAsset] = useState("Equity");

  const [isAscending, setIsAscending] = useState(false);
  const [isAscending1, setIsAscending1] = useState(true);
  const [isAscending2, setIsAscending2] = useState(true);

  const [filterDate, setFilterDate] = useState(null);

  const handleIconClick = (columnName) => {
    // Toggle between ascending and descending icons

    setOrderBy(columnName);

    switch (columnName) {
      case "created_at":
        setIsAscending(!isAscending);
        setOrder(isAscending ? "DESC" : "ASC");
        break;
      case "investment_amount":
        setIsAscending2(!isAscending2);
        setOrder(isAscending2 ? "DESC" : "ASC");
        break;
      default:
        setIsAscending(!isAscending);
        setOrder(isAscending ? "DESC" : "ASC");
        break;
    }

  };

  useEffect(() => {
    const fetchCountryList = async () => {
      const url = `${apiEndPoint}/country_master`;
         const payload = encryptData({
        data: {
          user_id: "1" // Replace with the actual user_id if dynamic
        }
       });
  
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: payload,
        });
  
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        const responseData = await response.json();
        //const data = responseData.data; // Flatten the response
        const data = decryptData(responseData);
        const formattedCountryData = data.data.map((country) => ({
          label: country.country_name,
          value: country.dial_no,
        }));

        setCountryData(formattedCountryData);
  
      } catch (error) {
        setErrorMessage(error.message);
        setMessageType('error');
        return false;
      }
    };
  
    fetchCountryList();
  }, []);


const fetchGlobalReport = () => {
  setGlobalLoading(true);

  // Close any existing connection
  if (abortControllerRefGlobal.current) {
    abortControllerRefGlobal.current.abort();
  }

  try {
    const zonedDate = moment(filterDate).isValid() ? moment(filterDate).tz(timeZone).format() : '';
    const requestData = encryptData({
      data: {
        user_id: "1",
        limit: pageRange,
        page: currentPage.toString(),
        q: searchInput || "",
        order: order,
        country: countryCode || "",
        orderBy: orderBy,
        status: progressId,
        filter_date: zonedDate || "",
        payment_status: statusId,
      },
    });

     const apiUrl = `${apiEndPoint}/leads`;
    const controller = new AbortController();
    abortControllerRefGlobal.current = controller;

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/event-stream',
      },
      body: requestData,
      signal: controller.signal,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        const readStream = () => {
          reader.read().then(({ done, value }) => {
            if (done) {
              setGlobalLoading(false);
              console.log('SSE stream closed');
              return;
            }

            const chunk = decoder.decode(value, { stream: true });
            const lines = chunk.split('\n');

            lines.forEach((line) => {
              if (line.startsWith('data:')) {
                try {
                  const jsonData = JSON.parse(line);
                  const decrypted = decryptData(jsonData);

                  if (decrypted.status === 'success') {
                    setGlobalLoading(false);
                    setReportCount(decrypted.count);
                    setReportData(decrypted.data);
                  } else {
                    setGlobalLoading(false);
                    setReportCount(decrypted.count);
                    setReportData(decrypted.data);
                    // toastIdRef.current = toast({ description: decrypted.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom' });
                  }
                } catch (error) {
                  console.error('Error parsing SSE data:', error);
                }
              }
            });

            readStream();
          }).catch((error) => {
            if (error.name === 'AbortError') {
              console.log('SSE request cancelled');
            } else {
              setGlobalLoading(false);
              setErrorMessage(error.message);
              setMessageType('error');
            }
          });
        };

        readStream();
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          console.log('SSE request cancelled');
        } else {
          setGlobalLoading(false);
          setErrorMessage(error.message);
          setMessageType('error');
        }
      });
  } catch (error) {
    setGlobalLoading(false);
    setErrorMessage(error.message);
    setMessageType('error');
  }
};

 const debouncedFetchGlobalReport = useCallback(
    debounce(() => {
      fetchGlobalReport();
    }, 1000),
    [searchInput] // Only debounce on search input changes
  );

  useEffect(() => {
    debouncedFetchGlobalReport();
    return () => {
      debouncedFetchGlobalReport.cancel();
    };
  }, [searchInput]);

  useEffect(() => {
    fetchGlobalReport();
  }, [currentPage, countryCode,pageRange,filterDate,progressId,order,orderBy,statusId]); // Regular effect for other dependencies

  const handleSearch = (event) => {
    console.log(event.target.value);

    setSearchInput(event.target.value);
    setCurrentPage(1); // Reset to the first page for new search
  };


  const [customPaginationValue, setCustomPaginationValue] = useState("");

  // Debounced function to update the page number
  const debouncedSetPage = useCallback(
    debounce((page) => {
      setCurrentPage(page);
    }, 1000), // Delay of 500ms (half a second)
    []
  );

  const handlePaginationChange = (e) => {
    const value = (e.target.value == 0 ? 1 : e.target.value).toString();
    setCustomPaginationValue(value); // Update input value immediately for fast typing
    debouncedSetPage(Number(value)); // Trigger the debounced function
  };

  const handlePagelimit = (value) => {
    setCurrentPage(1);
    setCustomPaginationValue(1);
    setPageRange(value);
  };

  const renderPagination = () => {
    // Calculate total number of pages
    const totalPages = Math.ceil(reportCount / pageRange);

    // Show a default of 3 pages if the total pages are more than 3
    const pageNumbers = [];
    const visiblePageCount = 4; // Number of pages to show by default

    let startPage = currentPage - 1;
    let endPage = currentPage + 2;

    // Adjust pagination if total pages are less than the default
    if (totalPages <= visiblePageCount) {
      startPage = 1;
      endPage = totalPages;

    } else {

      // Ensure the pagination does not go out of bounds
      startPage = Math.max(1, startPage);
      endPage = Math.min(totalPages, endPage);
    }

    // Create page numbers to display based on current page
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <nav aria-label="..." id='pagination_row' style={{ alignItems: 'center', justifyContent: 'space-between', background: '#FFF', paddingTop: 0, paddingBottom: 0, zIndex: 3 }}>
        <div className='totalRecords'>
          Total Records :  {Number(reportCount).toLocaleString()}
        </div>
        <ul className="pagination" style={{ border: 0, background: 'none' }}>

          <li class="page-item" style={{ marginLeft: 10 }}>
            <SelectPicker onChange={handlePagelimit} cleanable={false}
              value={pageRange}
              placement="top" placeholder='Pages' data={PagingData} searchable={false} style={{ width: 85, height: 35, display: 'flex', alignItems: 'center', borderRadius: 5, border: '1px solid #A1B9ED' }} />
          </li>

          {/* Previous Page (Double Arrow) */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`} style={{ marginLeft: 10 }}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
              <i className="fa fa-angle-double-left"></i>
            </a>
          </li>

          {/* Previous Page (Single Arrow) */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}>
              <i className="fa fa-angle-left"></i>
            </a>
          </li>

          {/* Page numbers */}
          {pageNumbers.map(page => (
            <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
              <a
                className="page-link" href="#"
                onClick={() => setCurrentPage(page)} // Set the clicked page as the current page
              >
                {page}
              </a>
            </li>
          ))}

          {/* Next Page (Single Arrow) */}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}>
              <i className="fa fa-angle-right"></i>
            </a>
          </li>

          {/* Next Page (Double Arrow) */}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`} style={{ marginRight: 10 }}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(totalPages)}>
              <i className="fa fa-angle-double-right"></i>
            </a>
          </li>

          {/* Go to Page */}
          <li className="page-item" style={{ marginLeft: 10, display: 'flex', alignItems: 'center', gap: 5 }}>
            <input
              type="text"
              placeholder="Go#"
              className="form-control"
              value={customPaginationValue}
              onChange={handlePaginationChange}
              onInput={(e) => {
                // Only allow numbers
                e.target.value = e.target.value.replace(/[^0-9]/g, '');
              }}

              style={{
                padding: '0px 10px',
                color: '#878787',
                fontSize: 16,
                borderRadius: 5,
                border: '1px solid #A1B9ED',
                width: 60,
                height: 35,
                textAlign: 'center'
              }}
            />
          </li>
        </ul>
      </nav>
    );
  };





  // PAGINATION
  const PagingData = ['10', '20', '50', '100'].map(
    item => ({ label: item, value: item })
  );

  const handleClearFilters = () => {
    setCurrentPage(1);
    setSearchInput("");
    setSearchAsset("");
    setCountryCode("");
    setStatusId("");
    setComplianceId("");
    setOrder("");
    setProgressId("");
    setScoreId("");
    setFilterDate(null);

  };


  const handleAssetClass = (value) => {
    setSearchAsset(value);
    setCurrentPage(1); // Reset to the first page for new search
  };




  const handleCountryChange = (value) => {
    setCurrentPage(1);
    setCountryCode(value);
  };





  const handleStatusChange = (value) => {
    setStatusId(value);
  };

  const handleComplianceChange = (value) => {
    setCurrentPage(1);
    setComplianceId(value);
  };

  const handleProgressStatus = (value) => {
    setCurrentPage(1);
    setProgressId(value);
  };

   const handleScoreStatus = (value) => {
    setCurrentPage(1);
    setScoreId(value);
  };

  const handleorderChange = (value) => {
    setCurrentPage(1);
    setOrder(value);
  };





  const [openDeletePopover, setOpenDeletePopover] = useState(null);
  const [publishSymbol, setPublishSymbol] = useState("");
  // Function to handle checkbox click
  const handleCheckboxClick = (item) => {
    // Toggle the popover visibility for the specific item
    setPublishSymbol(item.Symbol)
    if (openDeletePopover === item.id) {
      setOpenDeletePopover(null); // Close the popover if it's already open
    } else {
      setOpenDeletePopover(item.id); // Open the popover
    }
  };

  // // Function to handle deletion confirmation
  // const handlePublishConfirm = (Symbol) => {


  //     console.log(`Publish report with Symbol: ${Symbol}`);
  //     setOpenDeletePopover(null); // Close the popover after confirmation
  // };

  const handlePublishConfirm = (item) => {
    // console.log(`Publish report with Symbol: ${Symbol}`);

    // Prepare the data to be sent in the API request
    const requestData = {
      data: {
        user_id: userid, // Replace with actual user_id if needed
        symbol: item.Symbol, // Use the symbol passed to the function
        publish: item.Published ? "false" : "true"
      }
    };



    setOpenDeletePopover(null); // Close the popover after confirmation
  };


  const handleCheckboxChange = (e, item) => {
    setPublishSymbol(item.Symbol)
    //e.stopPropagation(); // Prevents the event from bubbling up
    // Handle the checkbox change here
    // You can check e.target.checked to see if it's checked or unchecked
  };


  const [open, setOpen] = useState(false);
  const [CMPTopen, setCMPTOpen] = useState(false);
  const [NCMPTopen, setNCMPTOpen] = useState(false);
  const [DBFTopen, setDBFTOpen] = useState(false);
  const [Intrestopen, setIntrestOpen] = useState(false);
  const [DEBTopen, setDEBTOpen] = useState(false);

  //const toggleDropdown = () => setOpen(!open); // Toggle dropdown visibility
  const preventClose = (e) => e.stopPropagation();



  const hideMessage = () => {
    setMessageType(null);
  };

  // Error Message

  const renderMessage = () => {
    if (messageType) {
      setTimeout(hideMessage, 5000);
    };

    switch (messageType) {
      case 'success':
        return (
          <Message type="success" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: 'absolute', right: 0, top: 10, zIndex: 999 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              <div className='icon_error_msg Icon_success'>
                <div className='icon_error_msg_inner Icon_success_inner'>
                  <img src={IconCheckError} alt="Success Icon" />
                  <div className="progress-circle progress_circle_success"></div>
                </div>
              </div>
              <div className='error_msg_text error_msg_success_text'>
                <h5>Success</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      case 'error':
        return (
          <Message type="error" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: 'absolute', right: 0, top: 10, zIndex: 999 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              <div className='icon_error_msg Icon_error'>
                <div className='icon_error_msg_inner Icon_error_inner'>
                  <img src={IconError} alt="Error Icon" />
                  <div className="progress-circle progress_circle_error"></div>
                </div>
              </div>
              <div className='error_msg_text error_msg_error_text'>
                <h5>Error</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      case 'info':
        return (
          <Message type="info" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: 'absolute', right: 0, top: 10 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              <div className='icon_error_msg Icon_info'>
                <div className='icon_error_msg_inner Icon_info_inner'>
                  <img src={IconInfo} alt="Info Icon" />
                  <div className="progress-circle progress_circle_info"></div>
                </div>
              </div>
              <div className='error_msg_text error_msg_info_text'>
                <h5>Info</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      default:
        return null;
    }
  };



  // MODAL

  const [EditModalOpen, setEditModalOpen] = useState(false);
  const [editModalETFName, setEditModalETFName] = useState("");
  const [editModalETFSymbol, setEditModalSymbol] = useState("");
  const etfModelCommentRef = useRef(null);
  const [etfModelPublicComment, setEtfModelPublicComment] = useState("");
  const [etfModelPrivateComment, setEtfModelPrivateComment] = useState("");
  const [isModalETFLoading, setIsModalETFLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(0);

  const handleEditModalOpen = (item) => {
    setEditModalETFName(item.ETF_Name);
    setEditModalSymbol(item.Symbol);

    if (item.is_manual_set === "1") {
      setSelectedStatus(item.Compliance_status);
      // Update the textarea's value
      setEtfModelPublicComment(item.manual_public_msg || "");
      setEtfModelPrivateComment(item.is_manual_set_msg || "");
    }
    else {
      setSelectedStatus("");
      setEtfModelPublicComment(""); // Clear the comment if not manual set
      setEtfModelPrivateComment("");
    }

    setEditModalOpen(true);
  }
  const handleEditModalClose = () => setEditModalOpen(false);

  // const StatusData = ['Compliant', 'Non- Compliant', 'Doubtful', 'Uncovered'].map(
  //     item => ({ label: item, value: item })
  // );
  const StatusData = ['Zain Shaikh', 'Sana Rizvi', 'Ali Noor', 'Rehan Qureshi', 'Nida Sheikh'].map(item => ({ label: item, value: { 'Compliant': 'COMPLIANT', 'Non- Compliant': 'NON_COMPLIANT', 'Doubtful': 'QUESTIONABLE', 'Uncovered': 'NOT_UNDER_COVERAGE' }[item] }));

  //const CountryData = ['India', 'Saudi Arabia', 'USA', 'UAE', 'Pakistan'].map(item => ({ label: item, value: item }));

  const MembersData = ['Zain Shaikh', 'Sana Rizvi', 'Ali Noor', 'Rehan Qureshi', 'Nida Sheikh'].map(item => ({ label: item, value: item }));

  const FundedStatusData = [
  { label: 'Funded', value: 'funded' },
  { label: 'Un Funded', value: 'unfunded' },
];

  const SharesData = [
    '0 - 100',
    '101 - 500',
    '501 - 1,000'
  ].map(item => ({ label: item, value: item }));

  const progressStatus = ['Offline', 'Online', 'Signed', 'Waiting', 'Invited','Accepted','Inactive','Progress'].map(item => ({ label: item, value: item }));

  const ScoreStatus = ['85–100', '70–84', '50–69', '0–49'].map(item => ({ label: item, value: item }));

  const StatusData1 = ['Committed', 'Funded', 'Interest Express', 'Cancelled', 'Completed'].map(item => ({ label: item, value: item }));


  useEffect(() => {
    if (etfModelCommentRef.current) {
      etfModelCommentRef.current.value = etfModelPublicComment;
    }
  }, [etfModelPublicComment]);



  const handleManualSave = async () => {

    if (!selectedStatus) {
      setErrorMessage('Please select new compliance status');
      setMessageType('error');
      return false;
    }

    if (!etfModelPrivateComment) {
      setErrorMessage('Please add a Private comment before submitting.');
      setMessageType('error');
      return false;
    }




  };

  const handleManualReset = async () => {


    setIsModalETFLoading(true);


  };

  const handleFilterDateChange = (value) => {
    setCurrentPage(1);


    setFilterDate(value);
  };



  const handleETFStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption); // Update selectedPeriod state with the selected option
  };

  const triggerRef = React.useRef();
  const openUncovered = () => triggerRef.current.openUncovered();
  const closeUncovered = () => triggerRef.current.closeUncovered();

  // TRUNCATE
  function truncateText(text, maxLength = 14) {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  }

  function address__truncate(text, maxLength = 22) {
  if (typeof text !== 'string') return '-';
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
}

 function notes__truncate(text, maxLength = 30) {
  if (typeof text !== 'string') return '-';
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
}


   const [expandedRowId, setExpandedRowId] = useState(null);

  const handleRowClick = (id) => {
    console.log(expandedRowId + ' : ' + id);
    if (expandedRowId == id) {
      setExpandedRowId(null);
    }
    else {
      // Toggle the expanded row
      setExpandedRowId(id);
      //setExpandedRowId(prevId => (prevId === id ? null : id));

    }

  };



  // REODER DRAG COLUMNS
  const [columnOrder, setColumnOrder] = useState([
    "Lead ID",
    "Duplicate Email Occurrences",
    "Full Name",
    "Email Address",
    "Phone Number",
    "Address",
    "Country",
    "Likehood Score",
    "Status",
    "Progress State",
    "Date Invited",
    "Payment",
    "Investment Amount",
    "Shares",
    "Share Price",
    "Web User",
    "Plateform Usage",
    "Time of Invite",
    "Time Based Bonus",
    "Amount Based Bonus",
    "Existing Investor Bonus",
    "Premium Subscription Bonus",
    "Total Bonus",
    "Accredited",
    "Check Status",
    "Notes",
  ]);

  const [draggedColumn, setDraggedColumn] = useState(null);

  const handleDragStart = (e, col) => {
    setDraggedColumn(col);

    const dragPreview = document.createElement("div");
    dragPreview.style.position = "absolute";
    dragPreview.style.top = "-9999px";
    dragPreview.style.padding = "6px 16px";
    dragPreview.style.background = "#FFD791";
    dragPreview.style.border = "1px solid #99bde0";
    dragPreview.style.borderRadius = "4px";
    dragPreview.style.color = "#000";
    dragPreview.style.fontSize = "16px";
    dragPreview.style.fontWeight = "bold";
    dragPreview.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.15)";
    dragPreview.textContent = col;

    document.body.appendChild(dragPreview);
    e.dataTransfer.setDragImage(dragPreview, 0, 0);

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(dragPreview);
    }, 0);
  };

  // const handleDrop = (e, targetCol) => {
  //   e.preventDefault();
  //   const fromIndex = columnOrder.indexOf(draggedColumn);
  //   const toIndex = columnOrder.indexOf(targetCol);

  //   if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) return;

  //   const newOrder = [...columnOrder];
  //   const [moved] = newOrder.splice(fromIndex, 1);
  //   newOrder.splice(toIndex, 0, moved);

  //   const thElements = document.querySelectorAll("th");
  //   const tdElements = document.querySelectorAll("tbody tr");

  //   // FLIP: First — Get starting positions
  //   const firstPositions = {};
  //   columnOrder.forEach((key) => {
  //     const th = document.querySelector(`th[data-column-id="${key}"]`);
  //     if (th) firstPositions[key] = th.getBoundingClientRect().left;
  //   });

  //   setColumnOrder(newOrder); // Update DOM

  //   // Wait for re-render
  //   requestAnimationFrame(() => {
  //     // Animate headers (FLIP)
  //     newOrder.forEach((key) => {
  //       const th = document.querySelector(`th[data-column-id="${key}"]`);
  //       const oldX = firstPositions[key];
  //       if (!th || oldX === undefined) return;

  //       const newX = th.getBoundingClientRect().left;
  //       const dx = oldX - newX;

  //       if (dx !== 0) {
  //         th.style.transform = `translateX(${dx}px)`;
  //         th.classList.add("animating");

  //         requestAnimationFrame(() => {
  //           th.style.transform = "";
  //         });

  //         setTimeout(() => {
  //           th.classList.remove("animating");
  //         }, 400);
  //       }
  //     });

  //     // Animate movedColumn cells
  //     const movedColumn = draggedColumn; // dynamically get the dragged column id
  //     const cells = document.querySelectorAll(`[data-column-id="${movedColumn}"]`);
  //     cells.forEach((cell) => {
  //       void cell.offsetWidth; // force reflow to restart animation
  //       cell.classList.add("column-drop-animate");
  //     });

  //     setTimeout(() => {
  //       cells.forEach((cell) => {
  //         cell.classList.remove("column-drop-animate");
  //       });
  //     }, 850);


  //   });




  //   setDraggedColumn(null);
  // };


  const handleDragOver = (e) => {
    e.preventDefault(); // Required to allow drop
  };

  // 🟩 Drag end
  const handleDragEnd = () => {
    setDraggedColumn(null);
  };

  const handleDrop = (e, targetColumnKey) => {
    e.preventDefault();

    const draggedIndex = columnOrder.indexOf(draggedColumn);
    const targetIndex = columnOrder.indexOf(targetColumnKey);

    if (
      draggedIndex === -1 ||
      targetIndex === -1 ||
      draggedIndex === targetIndex
    ) {
      setDraggedColumn(null);
      return;
    }

    // Temporarily disable scrollbar during animation
    const tableContainer = document.querySelector(".table").closest("div");
    if (tableContainer) {
      tableContainer.style.overflowY = "hidden";
    }

    const newColumnOrder = [...columnOrder];
    const [movedColumn] = newColumnOrder.splice(draggedIndex, 1);
    newColumnOrder.splice(targetIndex, 0, movedColumn);

    setColumnOrder(newColumnOrder);
    setDraggedColumn(null);
    // saveColumnOrder(newColumnOrder);

    // Apply drop animation with performance optimizations
    requestAnimationFrame(() => {
      // Find all cells with the movedColumn's data-column-id
      const cells = document.querySelectorAll(
        `[data-column-id="${movedColumn}"]`
      );

      // Get current table height to lock it during animation
      const table = document.querySelector("table");
      const tableHeight = table.offsetHeight;
      table.style.height = `${tableHeight}px`;

      cells.forEach((cell) => {
        // Force reflow to ensure animation restarts
        void cell.offsetWidth;
        cell.classList.add("column-drop-animate");
      });

      // Cleanup after animation completes
      setTimeout(() => {
        cells.forEach((cell) => {
          cell.classList.remove("column-drop-animate");
        });

        // Release table height constraint
        table.style.height = "";

        // Re-enable vertical scrolling if needed
        if (tableContainer) {
          tableContainer.style.overflowY = "";
        }

        // Optional: Highlight the table
        table.classList.add("table-highlight-column");
        setTimeout(() => {
          table.classList.remove("table-highlight-column");
        }, 600);
      }, 850); // Slightly longer than animation duration
    });
  };

  const [open2, setOpen2] = useState(false);

  const handleOpenDrawer = () => setOpen2(true);
  const handleCloseDrawer = () => setOpen2(false);


  function formatPhoneNumberGlobal(rawNumber) {
  if (!rawNumber) return rawNumber;
  const phoneNumber = parsePhoneNumberFromString(rawNumber);
  return phoneNumber ? phoneNumber.formatInternational().replace(/\s+/g, '-') : rawNumber;
}


  return (
    <>
      <Sidebar />
       <ChakraProvider resetCSS={false}>
                        <Wrap>
                        
                       </Wrap>
                      </ChakraProvider>

      <div id='header'>
        {renderMessage()}
        <div className='logo'>
          <div className='logo_icon'>
            <img src={Logo} />
          </div>
          <div className='brand_name'>Leads </div>
        </div>

        <div className='header_table_filter'>
          <div className='searchfield'>
            <button className='btn_search'><i className='icon-search2'></i></button>
            <input type='text' className='filter_searchfield' placeholder='Search' onChange={handleSearch} value={searchInput} />
          </div>



          <div className="dropdown_style filter_by_country">
            <SelectPicker
              data={countryData}
              searchable={true}
              style={{ width: 170 }}
              placeholder="Filter by Country"
              onChange={handleCountryChange}
              value={countryCode}
            />
          </div>

          <div className='dropdown_col_filter dropdown__select'>
            <SelectPicker
              data={FundedStatusData}
              searchable={false}
              style={{ width: 180 }}
              placeholder="Select Funding Status"
              onChange={handleStatusChange}
              value={statusId}
            />
          </div>

          <div className='dropdown_col_filter dropdown__select'>
            <SelectPicker
              data={progressStatus}
              searchable={false}
              style={{ width: 180 }}
              placeholder="Select Progress State"
              onChange={handleProgressStatus}
              value={progressId}
            />
          </div>

          <div className='dropdown_col_filter dropdown__select'>
            <SelectPicker
              data={ScoreStatus}
              searchable={false}
              style={{ width: 180 }}
              placeholder="Select Score"
              onChange={handleScoreStatus}
              value={scoreId}
            />
          </div>


          <div className='dropdown_col_filter dropdown__select'>
            <DatePicker
              oneTap
              style={{ width: 160 }}
              placeholder="Choose Date"
              format="dd-MM-yyyy"
              value={filterDate}
              onChange={handleFilterDateChange}
            />
          </div>



          {/* <div className='dropdown_style'>
                <SelectPicker
                    data={data}
                    searchable={false}
                    style={{ }}
                    placeholder="All Compliance statuses"
                    />
            </div>
            <div className='dropdown_style'>
                <SelectPicker
                    data={data}
                    searchable={false}
                    style={{ }}
                    placeholder="Both Publish Statuses"
                    />
            </div> */}

          <a href='javascript:void(0)' className="btn_clear_filter" style={{ textDecoration: "none" }} onClick={handleClearFilters}>Clear Filters</a>
        </div>
      </div>
      <div className="container-fluid content pb-5">

        <div className='company_table_list' data-aos="fade-up" data-aos-duration="800">

          {globalLoading && (<Placeholder.Grid rows={20} columns={9} active style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }} />)}

          {/* Table */}
          {!globalLoading && (
            <>
              <div className='table-responsive clsPagingWrap'>
                <table className='table table__iri__sticky'>
                  <thead>
                    <tr>
                      {columnOrder.map((col) => {
                        if (col === "Lead ID") {
                          return (
                            <th className='sticky-col left-col-1 waitlist_id_col' key={col}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span>Lead ID</span> <Button className='btn__refresh_header'><img src={IconRefresh} /></Button></div></th>
                          );
                        }
                         if (col === "Duplicate Email Occurrences") {
                          return (
                             <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Number of investments via email

</Tooltip>}>
                            <th className='sticky-col left-col-1 waitlist_id_col' key={col}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span>Count</span> </div></th>
                              </Whisper>
                          );
                        }
                        
                        if (col === "Full Name") {
                          return (
                            <th className='sticky-col left-col-2' key={col}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <span>Name</span>
                                <Button className='btn__cell_show' onClick={handleOpenDrawer}><img src={IconEye} /></Button>
                              </div>
                            </th>
                          );
                        }
                        if (col === "Email Address") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}><div className='cls_cell_Flex'>
                                <span>Email</span>
                                {/* <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>The data has not been tested</Tooltip>}><span className='cls_orange_dot'></span></Whisper> */}
                              </div>

                            </th>
                          );
                        }
                        if (col === "Phone Number") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}> <div className='cls_cell_Flex'>
                                <span>Phone</span>
                                {/* <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>The data is not reliable</Tooltip>}><span className='cls_red_dot'></span></Whisper> */}
                              </div></th>
                          );
                        }
                        if (col === "Address") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}>Address</th>
                          );
                        }
                        if (col === "Country") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Country</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}>Country</th>
                            </Whisper>
                          );
                        }

                        if (col === "Likehood Score") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Investment Likehood Score</Tooltip>}>
                              <th key={col} draggable onDragStart={(e) => handleDragStart(e, col)} onDrop={(e) => handleDrop(e, col)} onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>
                                  
                                  <div className='cls_cell_Flex'>
                                  <span>Likehood Score</span>
                                <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>The data not found</Tooltip>}><span className='cls_red_dot'></span></Whisper>
                              </div>

                               
                              </th>
                            </Whisper>
                          );
                        }
                        if (col === "Status") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Estimated Investment Timeline</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center'
                                }}>Status</th>
                            </Whisper>
                          );
                        }
                        if (col === "Progress State") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Investor Progress State</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}>Progress State</th>
                            </Whisper>
                          );
                        }
                        if (col === "Date Invited") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              onClick={() => handleIconClick("created_at")}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: 'center',
                              }}>Date Invited <img   src={isAscending ? icon_Asc : icon_Desc} style={{ height: 16, marginLeft: 10 }} alt={isAscending ? "Ascending Icon" : "Descending Icon"}></img></th>
                          );
                        }
                        if (col === "Payment") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: 'center',
                              }}>Payment</th>
                          );
                        }
                        if (col === "Investment Amount") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                               onClick={() => handleIconClick("investment_amount")}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: 'center',
                              }}>Investment Amount <img   src={isAscending2 ? icon2_Asc : icon2_Desc} style={{ height: 16, marginLeft: 10 }} alt={isAscending2 ? "Ascending Icon" : "Descending Icon"}></img></th>
                          );
                        }
                        if (col === "Shares") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: 'center',
                              }}>
                                 <div className='cls_cell_Flex'>
                                  <span>Shares</span>
                                <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>The data not found</Tooltip>}><span className='cls_red_dot'></span></Whisper>
                              </div>
                              </th>
                          );
                        }
                        if (col === "Share Price") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: 'center',
                              }}> <div className='cls_cell_Flex'>
                                  <span>Share Price</span>
                                <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>The data not found</Tooltip>}><span className='cls_red_dot'></span></Whisper>
                              </div>
                              </th>
                          );
                        }
                        if (col === "Web User") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>App/Web User</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Web User</th>
                            </Whisper>
                          );
                        }
                        if (col === "Plateform Usage") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: 'center',
                              }}><div className='cls_cell_Flex'>
                                  <span>Plateform Usage</span>
                                <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>The data not found</Tooltip>}><span className='cls_red_dot'></span></Whisper>
                              </div></th>
                          );
                        }
                        if (col === "Time of Invite") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Subscription Tier at Time of Invite</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",

                                }}>Time of Invite</th>
                            </Whisper>
                          );
                        }
                        if (col === "Time Based Bonus") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: 'center',
                              }}>Time Based Bonus</th>
                          );
                        }
                        if (col === "Amount Based Bonus") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Amount Based Bonus</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Amount Based Bonus</th>
                            </Whisper>
                          );
                        }
                        if (col === "Existing Investor Bonus") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Existing Investor Bonus</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Investor Bonus</th>
                            </Whisper>
                          );
                        }
                        if (col === "Premium Subscription Bonus") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}>Premium Subscription Bonus</th>
                          );
                        }
                        if (col === "Total Bonus") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}>Total Bonus</th>
                          );
                        }
                        if (col === "Accredited") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Accredited Status</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}><div className='cls_cell_Flex'>
                                <span>Accredited</span>
                                <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>The data is not reliable</Tooltip>}><span className='cls_red_dot'></span></Whisper>
                              </div></th>
                            </Whisper>
                          );
                        }
                        if (col === "Check Status") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Background Check Status</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}>Check Status</th>
                            </Whisper>
                          );
                        }
                        if (col === "Notes") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}>Notes</th>
                          );
                        }
                        return null;
                      })}
                    </tr>
                  </thead>

                  <tbody>

                     {reportdata && reportdata.length === 0 ? (
                       <tr>
                          <td colSpan="14" style={{ textAlign: "center", fontSize:20, paddingTop:60, paddingBottom:30 }}>
                            No data available
                          </td>
                        </tr>
              ) : (
                reportdata &&
                reportdata.map((item, index) => (
                  <>
                    <tr onClick={() => handleRowClick(index)} className='accordion-toggle collapsed' style={{ cursor: 'pointer' }}>
                      {columnOrder.map((col) => {
                        if (col === "Lead ID") return <td key={col}>LD-{item.id}</td>;
                        if (col === "Duplicate Email Occurrences") return <td key={col}>{item.more_invesment_count > 0 && <span className='entry_number'>{item.more_invesment_count}</span>}</td>;
                        

                        if (col === "Full Name")
                          return (
                            <td key={col} style={{ fontWeight: 600 }} >
                              <div className="name__col_cell"><span>{item.name}</span></div>
                            </td>
                          );
                        if (col === "Email Address") return <td key={col} data-column-id={col}>{item.email}</td>;
                        if (col === "Phone Number") return <td key={col} style={{ fontWeight: 600 }} data-column-id={col}>{formatPhoneNumberGlobal(item.phone)}</td>; //formatPhoneNumberGlobal(item.phone)
                        if (col === "Address") return <td key={col} style={{ fontWeight: 600 }} data-column-id={col}>
                          <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>{item.address}</Tooltip>}>
                            <span style={{cursor:'pointer'}}>
                              {address__truncate(item.address)}
                            </span>
                          </Whisper>
                        </td>;
                        if (col === "Country") return <td key={col} style={{}} data-column-id={col}>
                          <div className="company_name_td">
                                                  {item.country ? (
                                                    <>
                                                      <div className="clogo">
                                                        <CircleFlag countryCode={item.countryCode?.toLowerCase()} style={{ width: 30, height: 30 }} />
                                                      </div>
                                                      {item.country}
                                                    </>
                                                  ) : (
                                                    <div className="clogo">-</div>
                                                  )}
                                                </div>
                        </td>;
                        if (col === "Likehood Score") return <td key={col} style={{ textAlign: 'center' }} data-column-id={col}>{item.likelihood_score || '-' }</td>;
                        if (col === "Status") return <td key={col} style={{}} data-column-id={col}><span className={`lead__status ${{ 'Offline': 'lead__status_offline', 'Online': 'lead__status_online', 'signed': 'lead__status_signed', 'Waiting for Countersignature': 'lead__status_waiting_countersignature', 'invited': 'lead__status_invited', 'Accepted': 'lead__status_accepted', 'inactive': 'lead__status_inactive', 'Questionnaire in Progress': 'lead__status_questionnaire' }[item.status] || ''}`}>{item.status || '-'}</span></td>;
                        if (col === "Progress State") return <td style={{}} data-column-id={col}><span className='lead__progress__state'>{item.investor_progress_state || '-'}</span></td>;
                        if (col === "Date Invited") return <td style={{ textAlign: 'center', fontWeight: 600 }} data-column-id={col}>{item.date_invited || '-'}</td>;
                        if (col === "Payment") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.payment || '-'}</td>;
                        if (col === "Investment Amount") return <td style={{ textAlign: 'center', fontWeight: 600 }} data-column-id={col}>{item.investment_amount || '-'}</td>;
                        if (col === "Shares") return <td style={{ textAlign: 'center', fontWeight: 600 }} data-column-id={col}>{item.share || '-'}</td>;
                        if (col === "Share Price") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.share_price || '-'}</td>;
                        if (col === "Web User") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.user_platform || '-'}</td>;
                        if (col === "Plateform Usage") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.platform_usage || '-'}</td>;
                        if (col === "Time of Invite") return <td style={{ textAlign: 'center' }} data-column-id={col}><span className={` ${ { 'PREMIUM': 'tier__tag tier_premium', 'FREEMIUM': 'tier__tag tier_freemium', 'STARTER': 'tier__tag tier_starter', 'PREMIUM_PLUS': 'tier__tag tier_premium_plus', 'Not a user': 'tier__tag tier_not_user' }[item.subscription] || '' }`}>{item.subscription || '-'}</span></td>;
                        if (col === "Time Based Bonus") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.time_based_bonus || '-'}</td>;
                        if (col === "Amount Based Bonus") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.amount_based_bonus || '-'}</td>;
                        if (col === "Existing Investor Bonus") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.existing_investor_bonus || '-'}</td>;
                        if (col === "Premium Subscription Bonus") return <td style={{ fontWeight: 600, textAlign: 'center' }} data-column-id={col}>{item.premium_subscription_bonus || '-'}</td>;
                        if (col === "Total Bonus") return <td style={{ textAlign: 'center', fontWeight: 600 }} data-column-id={col}>{item.total_bonus || '-'}</td>;
                        if (col === "Accredited") return <td style={{ textAlign: 'center' }} data-column-id={col}><span>{item.accredited || '-'}</span></td>;
                        if (col === "Check Status") return <td style={{}} data-column-id={col}><span className={`tag_td ${ { 'Passed': 'halal_tag', 'Pending': 'doughtful_tag', 'Flagged': 'not_halal_tag' }[item.background_check] || '' }`} style={{ maxWidth: 110 }}>{item.background_check || '-'}</span></td>;
                        if (col === "Notes") return <td style={{}} data-column-id={col}>
                          
                          <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>{item.notes}</Tooltip>}>
                            <span style={{cursor:'pointer'}}>
                              {notes__truncate(item.notes)}
                            </span>
                          </Whisper>
                          </td>;
                        return null;
                      })}
                    </tr>

                     <tr className="hiddenRow">
                                                    <td colspan="32" style={{ padding: 0, position: 'sticky', left: 0 }}>
                    
                                                      <div className={`accordian-body collapse ${expandedRowId === index ? 'show' : 'hide'}`} id={`TableRow${index}`}>
                    
                                                        {item.more_invesment?.length > 0 ? (
                                                          <div className='table_accordion_row'>
                                                            <div className='table_accordion_col' style={{ width: '100%' }} >
                                                              <div className='etf_details_row pb-2'>
                                                                <h4>Investor Details</h4>
                                                              </div>
                    
                                                              <div className='etf_fieldset_row etf_fieldset_row_new'>
                                                                <fieldset className='fieldset_col three_rows_fieldset'>
                                                                  <legend className='legend_title'>Investment Details</legend>
                    
                                                                  {item.more_invesment?.map((subitem, i) => (
                    
                                                                    <div className='purification_fieldset_row'>
                                                                      <div className='input__group_redis'>
                                                                        <div className='input__group_redis_label'>
                                                                          Investor ID
                                                                        </div>
                                                                        <div className='input__group_redis_value'>
                                                                          {subitem.id}
                                                                        </div>
                                                                      </div>
                    
                                                                      <div className='input__group_redis'>
                                                                        <div className='input__group_redis_label'>
                                                                          Investment Amount
                                                                        </div>
                                                                        <div className='input__group_redis_value'>
                                                                          {subitem.investment_amount}
                                                                        </div>
                                                                      </div>
                    
                                                                      <div className='input__group_redis'>
                                                                        <div className='input__group_redis_label'>
                                                                          status
                                                                        </div>
                                                                        <div className='input__group_redis_value'>
                                                                          {subitem.status}
                                                                        </div>
                                                                      </div>
                                                                      <div className='input__group_redis'>
                                                                        <div className='input__group_redis_label'>
                                                                          Payment
                                                                        </div>
                                                                        <div className='input__group_redis_value'>
                                                                          {subitem.payment}
                                                                        </div>
                                                                      </div>
                    
                                                                       <div className='input__group_redis'>
                                                                        <div className='input__group_redis_label'>
                                                                          Created At
                                                                        </div>
                                                                        <div  className={`input__group_redis_value`}>
                                                                          {subitem.created_at}
                                                                        </div>
                                                                      </div>
                                                                    </div>
                    
                                                                  ))}
                                                                </fieldset>
                                                              </div>
                    
                                                            </div>
                                                          </div>
                                                        ) : (
                                                          <>
                                                            <div className='table_accordion_row'>
                                                              <div className='table_accordion_col' style={{ width: '100%' }} >
                                                                <div className='etf_details_row pb-2'>
                                                                  <h4>No History Found</h4>
                                                                </div>
                    
                    
                                                              </div>
                                                            </div>
                    
                                                          </>
                                                        )}
                    
                                                      </div>
                    
                                                    </td>
                      </tr>
                  </>
))
              )}
                

                  </tbody>
                </table>

              </div>
              {reportCount > 1 && renderPagination()}
            </>
          )}
        </div>
      </div>

      <Modal open={EditModalOpen} onClose={handleEditModalClose}
        className="edit_status_modal modal_vflex_end slide-from-right"
        placement="right"
        transition
      >
        <Modal.Header className="edit_modal_header">
          <Modal.Title className="edit_modal_title">Update Waiting List</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="edit_modal_content">
            <div className="edit_status_field">
              <div class="duplicate_form_row">
                <div class="duplicate_form_col">
                  <label>Phone Number</label>
                  <input type='text' placeholder='Enter Number' className='form-control' />
                </div>
                <div class="duplicate_form_col">
                  <label>Country</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Country Residence"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Preferred Language</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Language"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>Opt-In Consent</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Opt-In Consent"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Inv. Int. Amount</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Int. Amount"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>Est. Inv. Timeline</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Timeline"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Accredited Investor Status</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Acc. Inv. Status"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>Investor Type</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Investor Type"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Investment Likelihood Score</label>
                  <input type='text' placeholder='Inv. Likelihood Score' className='form-control' />
                </div>
                <div class="duplicate_form_col">
                  <label>Status</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Status"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Priority Level</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Level"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>IR Tags</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select IR Tags"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Priority Level</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Level"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>IR Tags</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select IR Tags"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col" style={{ width: '100%' }}>
                  <label>IR Notes</label>
                  <textarea className='form-control' placeholder='Notes' rows={3} style={{ height: 'auto' }}></textarea>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal_footer_edit_status">
          <div className="btn__group">
            <button type="button" className="btn_cancel" onClick={handleEditModalClose}>Cancel</button>
            <button className="btn__save" onClick={handleManualSave}>Update</button>
          </div>
        </Modal.Footer>
      </Modal>

      <Drawer open={open2} onClose={handleCloseDrawer} size="xs" placement="left" className='show_hide_drawer'>
        <Drawer.Header>
          <Drawer.Title>Show & Hide Columns</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          {/* Static Checkboxes */}
          <div style={{ marginTop: 30 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="Email"
                />
                <label
                  class="form-check-label"
                  htmlFor="Email"
                >
                  Email Address
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="PhoneNumber"
                />
                <label
                  class="form-check-label"
                  htmlFor="PhoneNumber"
                >
                  Phone Number
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="CountryofResidence"
                />
                <label
                  class="form-check-label"
                  htmlFor="CountryofResidence"
                >
                  Country
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="PreferredLanguage"
                />
                <label
                  class="form-check-label"
                  htmlFor="PreferredLanguage"
                >
                  Preferred Language
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="PreferredContactMethod"
                />
                <label
                  class="form-check-label"
                  htmlFor="PreferredContactMethod"
                >
                  Preferred Contact Method
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="Opt-InConsent"
                />
                <label
                  class="form-check-label"
                  htmlFor="Opt-InConsent"
                >
                  Opt-In Consent
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="InvestmentInterestAmount"
                />
                <label
                  class="form-check-label"
                  htmlFor="InvestmentInterestAmount"
                >
                  Investment Amount
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="EstimatedInvestmentTimeline"
                />
                <label
                  class="form-check-label"
                  htmlFor="EstimatedInvestmentTimeline"
                >
                  Estimated Investment Timeline
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="AccreditedInvestorStatus"
                />
                <label
                  class="form-check-label"
                  htmlFor="AccreditedInvestorStatus"
                >
                  Accredited Investor Status
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="InvestorType"
                />
                <label
                  class="form-check-label"
                  htmlFor="InvestorType"
                >
                  Investor Type
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="InvestmentLikelihoodScore"
                />
                <label
                  class="form-check-label"
                  htmlFor="InvestmentLikelihoodScore"
                >
                  Investment Likelihood Score
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="PlatformUserMatch"
                />
                <label
                  class="form-check-label"
                  htmlFor="PlatformUserMatch"
                >
                  Platform App/Web User
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="App/WebUsageDetected"
                />
                <label
                  class="form-check-label"
                  htmlFor="App/WebUsageDetected"
                >
                  App/Web Usage Detected
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="SubscriptionTierSubmission"
                />
                <label
                  class="form-check-label"
                  htmlFor="SubscriptionTierSubmission"
                >
                  Subscription Tier at Subscription
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="SubscriptionTierDuration"
                />
                <label
                  class="form-check-label"
                  htmlFor="SubscriptionTierDuration"
                >
                  Subscription Tier Duration (Days)
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="PlatformRegistrationDate"
                />
                <label
                  class="form-check-label"
                  htmlFor="PlatformRegistrationDate"
                >
                  Platform Date Invited
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="LeadOwner"
                />
                <label
                  class="form-check-label"
                  htmlFor="LeadOwner"
                >
                  Payment
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="LeadStatus"
                />
                <label
                  class="form-check-label"
                  htmlFor="LeadStatus"
                >
                  Status
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="PriorityLevel"
                />
                <label
                  class="form-check-label"
                  htmlFor="PriorityLevel"
                >
                  Priority Level
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IRTags"
                />
                <label
                  class="form-check-label"
                  htmlFor="IRTags"
                >
                  IR Tags (Custom Labels)
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IRNotes"
                />
                <label
                  class="form-check-label"
                  htmlFor="IRNotes"
                >
                  IR Notes
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="ContactHistoryLog"
                />
                <label
                  class="form-check-label"
                  htmlFor="ContactHistoryLog"
                >
                  Contact History Log
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="LastContactedDate"
                />
                <label
                  class="form-check-label"
                  htmlFor="LastContactedDate"
                >
                  Last Contacted Date
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="CreatedAt"
                />
                <label
                  class="form-check-label"
                  htmlFor="CreatedAt"
                >
                  Created At
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="LastUpdatedAt"
                />
                <label
                  class="form-check-label"
                  htmlFor="LastUpdatedAt"
                >
                  Last Updated At
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="UTMSource"
                />
                <label
                  class="form-check-label"
                  htmlFor="UTMSource"
                >
                  UTM Source
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="UTMCampaign"
                />
                <label
                  class="form-check-label"
                  htmlFor="UTMCampaign"
                >
                  UTM Campaign
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="UTMMedium"
                />
                <label
                  class="form-check-label"
                  htmlFor="UTMMedium"
                >
                  UTM Medium
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="ReferralCode"
                />
                <label
                  class="form-check-label"
                  htmlFor="ReferralCode"
                >
                  Referral Code
                </label>
              </div>
            </div>
          </div>
        </Drawer.Body>
        <Drawer.Footer>
          <Button className="btn__cancel" style={{ width: '100%', background: '#FFF' }}>Reset</Button>
        </Drawer.Footer>
      </Drawer>

    </>
  );
}

export default Leads;
